import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent, ListTableComponent, ListTableDataLoader } from '@ppl/ui';
import { map } from 'rxjs';
import { UserService } from '../../../../../services/user.service';
import { ENDPOINTS } from '../../../../../shared/constants/url.constants';
import { HttpRequestService } from '../../../../../shared/services/http-request.service';

@Component({
  selector: 'ppl-timesheet-payroll-run-errors',
  standalone: true,
  imports: [ListTableComponent, ButtonComponent],
  templateUrl: './timesheet-payroll-run-errors.component.html',
  styleUrl: './timesheet-payroll-run-errors.component.css',
})
export class TimesheetPayrollRunErrorsComponent implements OnInit {
  @ViewChild(ListTableComponent) listTable!: ListTableComponent;

  programName = '';
  lazyLoad = true;
  sharedDataKey = 'list_timesheet_payroll_run_errors';
  batchInstanceId = '';

  // The batch error list API already exists, so this reuses it with the
  // batch scoped in — same shape as the bulk adjustment error list.
  errorsDataLoader: ListTableDataLoader = (payload, context) =>
    this.http
      .post(ENDPOINTS.LIST_PAGE_DATA, this.addBatchFilter(payload), context?.hasUpdatedEntry)
      .pipe(map((response) => this.ensureGridColumns(response)));

  constructor(
    private userService: UserService,
    private router: Router,
    private http: HttpRequestService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.batchInstanceId =
      this.router.getCurrentNavigation()?.extras?.state?.['batchInstanceId'] ?? history.state?.batchInstanceId ?? '';
  }

  goBack(): void {
    this.router.navigate(['/home/timesheetPayrollProcessing']);
  }

  private addBatchFilter(payload: any): any {
    if (!this.batchInstanceId) {
      return payload;
    }

    const searchParam = Array.isArray(payload?.searchParam) ? [...payload.searchParam] : [];
    if (!searchParam.some((item: any) => item?.jsonPath === 'batchInstanceId')) {
      searchParam.push({ jsonPath: 'batchInstanceId', value: this.batchInstanceId, operator: 'Equal' });
    }

    return { ...payload, searchParam };
  }

  /** Derives headers from the first row when the API returns no column metadata. */
  private ensureGridColumns(response: any): any {
    if (Array.isArray(response?.GridColumns) && response.GridColumns.length > 0) {
      return response;
    }

    const firstRow = Array.isArray(response?.responsedata)
      ? response.responsedata.find((row: any) => row && typeof row === 'object')
      : undefined;

    if (!firstRow) {
      return response;
    }

    const preferredFields = ['batchInstanceId', 'error', 'status', 'modifiedBy', 'modifiedDate'];
    const keys = Object.keys(firstRow);
    const orderedFields = [
      ...preferredFields.filter((field) => keys.includes(field)),
      ...keys.filter((field) => !preferredFields.includes(field)),
    ];

    return {
      ...response,
      GridColumns: orderedFields.map((field) => ({
        dataColumnName: field,
        gridColumnName: this.getHeaderLabel(field),
      })),
    };
  }

  private getHeaderLabel(field: string): string {
    return field
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (character) => character.toUpperCase());
  }
}
